import { render } from "./MainBanner.vue?vue&type=template&id=5e0df14e&ts=true"
import script from "./MainBanner.vue?vue&type=script&lang=ts"
export * from "./MainBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__